/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  RenderTemplateByIDRequestBody,
  RenderTemplateByIDRequestBody$Outbound,
  RenderTemplateByIDRequestBody$outboundSchema,
} from "../components/rendertemplatebyidrequestbody.js";

export type RenderTemplateByIDSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type RenderTemplateByIDSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type RenderTemplateByIDSecurityOption3 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type RenderTemplateByIDSecurity = {
  option1?: RenderTemplateByIDSecurityOption1 | undefined;
  option2?: RenderTemplateByIDSecurityOption2 | undefined;
  option3?: RenderTemplateByIDSecurityOption3 | undefined;
};

export type RenderTemplateByIDRequest = {
  /**
   * The ID of the prompt template to render
   */
  id: string;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  renderTemplateByIDRequestBody: RenderTemplateByIDRequestBody;
};

/** @internal */
export type RenderTemplateByIDSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const RenderTemplateByIDSecurityOption1$outboundSchema: z.ZodMiniType<
  RenderTemplateByIDSecurityOption1$Outbound,
  RenderTemplateByIDSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function renderTemplateByIDSecurityOption1ToJSON(
  renderTemplateByIDSecurityOption1: RenderTemplateByIDSecurityOption1,
): string {
  return JSON.stringify(
    RenderTemplateByIDSecurityOption1$outboundSchema.parse(
      renderTemplateByIDSecurityOption1,
    ),
  );
}

/** @internal */
export type RenderTemplateByIDSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const RenderTemplateByIDSecurityOption2$outboundSchema: z.ZodMiniType<
  RenderTemplateByIDSecurityOption2$Outbound,
  RenderTemplateByIDSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function renderTemplateByIDSecurityOption2ToJSON(
  renderTemplateByIDSecurityOption2: RenderTemplateByIDSecurityOption2,
): string {
  return JSON.stringify(
    RenderTemplateByIDSecurityOption2$outboundSchema.parse(
      renderTemplateByIDSecurityOption2,
    ),
  );
}

/** @internal */
export type RenderTemplateByIDSecurityOption3$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const RenderTemplateByIDSecurityOption3$outboundSchema: z.ZodMiniType<
  RenderTemplateByIDSecurityOption3$Outbound,
  RenderTemplateByIDSecurityOption3
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function renderTemplateByIDSecurityOption3ToJSON(
  renderTemplateByIDSecurityOption3: RenderTemplateByIDSecurityOption3,
): string {
  return JSON.stringify(
    RenderTemplateByIDSecurityOption3$outboundSchema.parse(
      renderTemplateByIDSecurityOption3,
    ),
  );
}

/** @internal */
export type RenderTemplateByIDSecurity$Outbound = {
  Option1?: RenderTemplateByIDSecurityOption1$Outbound | undefined;
  Option2?: RenderTemplateByIDSecurityOption2$Outbound | undefined;
  Option3?: RenderTemplateByIDSecurityOption3$Outbound | undefined;
};

/** @internal */
export const RenderTemplateByIDSecurity$outboundSchema: z.ZodMiniType<
  RenderTemplateByIDSecurity$Outbound,
  RenderTemplateByIDSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => RenderTemplateByIDSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => RenderTemplateByIDSecurityOption2$outboundSchema),
    ),
    option3: z.optional(
      z.lazy(() => RenderTemplateByIDSecurityOption3$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
      option3: "Option3",
    });
  }),
);

export function renderTemplateByIDSecurityToJSON(
  renderTemplateByIDSecurity: RenderTemplateByIDSecurity,
): string {
  return JSON.stringify(
    RenderTemplateByIDSecurity$outboundSchema.parse(renderTemplateByIDSecurity),
  );
}

/** @internal */
export type RenderTemplateByIDRequest$Outbound = {
  id: string;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  RenderTemplateByIDRequestBody: RenderTemplateByIDRequestBody$Outbound;
};

/** @internal */
export const RenderTemplateByIDRequest$outboundSchema: z.ZodMiniType<
  RenderTemplateByIDRequest$Outbound,
  RenderTemplateByIDRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    renderTemplateByIDRequestBody: RenderTemplateByIDRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      renderTemplateByIDRequestBody: "RenderTemplateByIDRequestBody",
    });
  }),
);

export function renderTemplateByIDRequestToJSON(
  renderTemplateByIDRequest: RenderTemplateByIDRequest,
): string {
  return JSON.stringify(
    RenderTemplateByIDRequest$outboundSchema.parse(renderTemplateByIDRequest),
  );
}
